<template>
  <success :title="title" :btn-list="btnData" :type="type" :show-middle-close-btn="true">
    <p v-if="!exist" class="result-hd">如需放行请点击下面“全部车辆”的按钮</p>
  </success>
</template>
<script>

import Success from '../components/Success'
export default {
  components: {
    Success
  },
  data () {
    return {
      exist: 1,
      plate_number: '',
      btnData: [{
        link: `/barriergate/all/list`,
        name: '全部车辆'
      }]
    }
  },
  created () {
    this.exist = +this.$route.query.exist
    const plateNumber = this.$route.query.plate_number
    this.plate_number = plateNumber || ''
  },
  computed: {
    title: function () {
      let str = this.exist ? '已登记成功' : `当前车辆（${this.plate_number}）已进店`
      return str
    },
    type: function () {
      return !this.exist ? 'warn' : ''
    }
  },
  methods: {}
}

</script>
<style lang="less">
@import "../../stylesheets/modules/components/success.less";
</style>
